import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-slate-100 text-slate-700 py-6 mt-auto border-t border-slate-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <p className="text-base">
                        Developed by{' '}
                        <span className="font-bold text-red-800">
                            Karven Tech
                        </span>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
